var angular = require('angular')
var defaultTo = require('lodash/defaultTo')

var contentService = require('aem-libs-angularjs/src/services/content.service.js').contentService

require('aem-libs-angularjs/src/directives/track-element.directive.js')
require('../../components/input-checkbox/input-checkbox.component.js')
require('../../components/input-combobox/input-combobox.component.js')
require('../../components/input-pobocky/input-pobocky.component.js')
require('../../components/input-radio/input-radio.component.js')
require('../../components/input-text/input-text.component.js')
require('../../../ow-input-account-number/ow-input-account-number.component.js')
require('../../components/input-textarea/input-textarea.component.js')
require('../../components/input-date/input-date.component.js')
require('../../components/input-priloha/input-priloha.component.js')
require('aem-libs-angularjs/src/components/wcm-html-content/wcm-html-content.component.js')
require('../../service/is-uploading.dataservice.js')
require('../../service/wcm-document.dataservice.js')
require('aem-libs-angularjs/src/components/backend-error/backend-error.component.js')

var isObjectName = require('../../../../services/isObjectName')

angular.module('uniformCmp', ['TrackElementCmp', 'inputTextCmp', 'inputTextareaCmp',
  'inputCheckboxCmp', 'inputComboboxCmp', 'inputPobockyCmp', 'inputRadioCmp',
  'inputDateCmp', 'inputPrilohaCmp', 'WcmHtmlContentCmp', 'UploadingDataserviceCmp',
  'BackEndErrorComp', 'WcmDocumentDataserviceCmp', 'OwInputAccountNumberCmp'])
  .factory('visibilityDependencyDataservice', require('../../../../services/visibility-dependency.dataservice'))
  .component('uniform', {
    template: require('./uniform.component.tpl.html'),
    controller: UniformCtrl,
    controllerAs: 'vm',
    bindings: {
      fullData: '<',
      hideDate: '<',
      userTrackingParams: '<',
      submitFormElementId: '<',
      onSubmitted: '&'
    }
  })
  .factory('contentService', contentService)

require('./components/steps/steps.component.js')

UniformCtrl.$inject = ['uniformsService', 'appLoader', 'userTracking', '$window',
  '$timeout', 'contentService', 'wgService', 'isUploadingDataservice', '$q',
  'visibilityDependencyDataservice', 'wcmDocumentDataservice']

function UniformCtrl (uniformsService, appLoader, userTracking, $window,
  $timeout, contentService, wgService, isUploadingDataservice, $q,
  visibilityDependencyDataservice, wcmDocumentDataservice) {
  var vm = this

  vm.$onInit = function () {
    vm.values = {}
    vm.create = create
    vm.update = update
    vm.submit = submit
    vm.saveOrSubmitStep = saveOrSubmitStep
    vm.saveOrSubmit = saveOrSubmit
    vm.showSpinner = false
    vm.disabledButton = false
    vm.disabledRadioButton = false
    vm.setValidity = setValidity
    vm.messagesFromBE = null
    vm.isErrorBackend = false
    vm.wcmHrefContext = defaultTo(wgService.getParams().wcmHrefContext, '')
    vm.isObjectName = isObjectName
    vm.textBeforeWCM = {}
    vm.textAfterWCM = {}
    vm.textAfterSendingWCM = {}
    vm.multiStep = defaultTo(wgService.getParams().multiStep, '')
    vm.countOfGroups = vm.fullData.formFields.length | 0
    vm.onStepChanged = onStepChanged
    vm.fileContents = {}
    vm.isUploadingDataservice = isUploadingDataservice
    vm.processPromise = null
    vm.keepVisibleAfterSubmit = defaultTo(wgService.getParams().keepVisibleAfterSubmit, false)
    vm.autoUniformSubmit = defaultTo(wgService.getParams().autoUniformSubmit, false)
    vm.submitCounter = 0
    vm.isIdVisible = isIdVisible
    vm.onValueChanged = onValueChanged
    vm.setFormToPristine = setFormToPristine

    vm.fileContents = wcmDocumentDataservice.getFileContents(vm.fullData.formFields)

    isObjectName(vm.fullData.textBeforeWCM) && saveObjectNameContent(vm.fullData.textBeforeWCM, vm.textBeforeWCM)
    isObjectName(vm.fullData.textAfterWCM) && saveObjectNameContent(vm.fullData.textAfterWCM, vm.textAfterWCM)
    isObjectName(vm.fullData.textAfterSendingWCM) && saveObjectNameContent(vm.fullData.textAfterSendingWCM, vm.textAfterSendingWCM)

    if (vm.autoUniformSubmit) {
      $timeout(saveOrSubmit)
    }
  }

  // change event for one-way binded components
  function onValueChanged (value, formFieldId) {
    vm.values[formFieldId] = value
  }

  function saveOrSubmit () {
    // If form is valid, submit the form
    if (vm['form_' + vm.fullData.id].$valid) {
      document.getElementById('uniform-detail-component').scrollIntoView(true)
      if (!vm.opportunityId) {
        // If we do not have any opportunityID (first time submitting the form), create a new filledForm
        create()
      } else {
        update()
      }
    } else {
      setSpinner()
      userTracking.onValidityFailure()
    }
  }

  function removeEmptyArrayFromObject (obj) {
    for (var propName in obj) {
      if (angular.isArray(obj[propName]) && obj[propName].length === 0) {
        delete obj[propName]
      }
    }
  }

  function createRestData () {
    vm.url = $window.location.href
    vm.trackingHiddenFields = []

    for (var prop in vm.userTrackingParams) {
      for (var i = 0; i < vm.fullData.formFields.length; i++) {
        if (vm.fullData.formFields[i].defaultValueI18N === prop) {
          vm.trackingHiddenFields.push({
            'fieldId': vm.fullData.formFields[i].id,
            'values': [vm.userTrackingParams[prop]]
          })
        }
      }
    }

    var urlFieldId = vm.fullData.formFields.reduce(function (acc, cur) {
      if (cur.nameI18N === 'Zdroj leadu') {
        return cur.id
      } else {
        return acc
      }
    }, null)

    removeEmptyArrayFromObject(vm.values)
    var data = {
      formId: vm.fullData.id,
      fields: Object.keys(vm.values).map(function (key) {
        if (angular.isArray(vm.values[key])) {
          return {
            fieldId: key,
            values: vm.values[key]
          }
        }
        return {
          fieldId: key,
          values: [vm.values[key]]
        }
      })
    }
    data['fields'].push.apply(data.fields, vm.trackingHiddenFields)
    if (urlFieldId) {
      data['fields'].push({
        'fieldId': urlFieldId,
        'values': [vm.url]
      })
    }

    return data
  }

  function create () {
    var data = createRestData()

    if (!data.fields || !data.fields.length) {
      return
    }

    vm.disabledButton = true
    vm.disabledRadioButton = true
    vm.showSpinner = true
    appLoader.show()
    userTracking.onRequest(data, 'create')
    uniformsService.create(data)
      .then(function (response) {
        userTracking.onResponse(response.data, 'create')
        vm.opportunityId = response.data.opportunityId
        if (response.data.status === 'OK') {
          submit(response.data.messages)
        } else {
          if (response.data.messages) {
            vm.messagesFromBE = response.data.messages
            setValidity(vm.messagesFromBE)
            userTracking.onValidityFailure()
          }
          vm.disabledButton = false
          vm.disabledRadioButton = false
          vm.showSpinner = false
        }
      })
      .catch(function () {
        vm.isErrorBackend = true
        vm.disabledButton = false
        vm.disabledRadioButton = false
        vm.showSpinner = false
      })
      .finally(appLoader.hide)
  }

  function submit (messages) {
    vm.disabledButton = true
    vm.disabledRadioButton = true
    vm.showSpinner = true
    appLoader.show()
    userTracking.onRequest(vm.opportunityId, 'submit')
    uniformsService.submit(vm.opportunityId).then(function (response) {
      userTracking.onResponse(response.data, 'submit')
      vm.onSubmitted({
        params: {
          opportunityId: vm.opportunityId,
          processId: response.data.processId,
          messages: messages
        }
      })
      vm.submitCounter++
      if (vm.autoUniformSubmit && vm.submitCounter > 1) {
        vm.submitedForm = true
      } else if (!vm.autoUniformSubmit) {
        vm.submitedForm = true
      }
    }).catch(function () {
      vm.isErrorBackend = true
    }).finally(function () {
      appLoader.hide()
      vm.disabledButton = false
      vm.disabledRadioButton = false
      vm.showSpinner = false
    })
  }

  function update () {
    var data = createRestData()

    if (!data.fields || !data.fields.length) {
      return
    }

    vm.disabledButton = true
    vm.disabledRadioButton = true
    vm.showSpinner = true
    appLoader.show()
    userTracking.onRequest(vm.opportunityId, 'update')
    uniformsService.update(data, vm.opportunityId)
      .then(function (response) {
        userTracking.onRequest(response.data, 'update')
        if (response.data.status === 'OK') {
          submit()
        } else {
          if (response.data.messages) {
            vm.messagesFromBE = response.data.messages
            setValidity(vm.messagesFromBE)
            userTracking.onValidityFailure()
          }
          vm.disabledButton = false
          vm.disabledRadioButton = false
          vm.showSpinner = false
        }
      })
      .catch(function () {
        vm.isErrorBackend = true
        vm.disabledButton = false
        vm.disabledRadioButton = false
        vm.showSpinner = false
      })
      .finally(appLoader.hide)
  }

  function setSpinner () {
    vm.disabledButton = true
    vm.disabledRadioButton = true
    vm.showSpinner = true
    $timeout(function () {
      vm.disabledButton = false
      vm.disabledRadioButton = false
      vm.showSpinner = false
    }, 1000)
  }

  function setValidity (messages) {
    for (var i = 0; i < messages.length; i++) {
      if (messages[i].messages) {
        vm.userTrackingErrorFieldId = messages[i].fieldId
        var formName = 'vm.form_' + messages[i].fieldId
        var fieldName = 'field_' + messages[i].fieldId
        var fieldBox = document.getElementById(fieldName)
        if (fieldBox) {
          switch (messages[i].messages[0]) {
            case 'required':
              vm['form_' + vm.fullData.id][formName][fieldName].$setValidity('required', false)
              break

            case 'invalid.birthNumber.modulo':
              vm['form_' + vm.fullData.id][formName][fieldName].$setValidity('invalid_birthNumber_modulo', false)
              break

            case 'attachment.invalidExtension':
              vm['form_' + vm.fullData.id][formName][fieldName].$setValidity('attachment_invalidExtension', false)
              break

            case 'attachment.maxSizeExceeded':
              vm['form_' + vm.fullData.id][formName][fieldName].$setValidity('attachment_maxSizeExceeded', false)
              break

            default:
              vm['form_' + vm.fullData.id][formName][fieldName].$setValidity('invalidDefault', false)
          }
        }
      }
    }
  }

  function setFormToPristine () {
    vm['form_' + vm.fullData.id].$setPristine(true)
  }

  function saveObjectNameContent (objectName, variable) {
    contentService.getStaticHtml('internet', objectName).promise
      .then(function (res) {
        variable.content = res.data
      })
  }

  function onStepChanged (arrayItems) {
    vm.disabledButton = true
    vm.showSpinner = true
    vm['form_' + vm.fullData.id].$setSubmitted()
    if (!vm.opportunityId) {
      // If we do not have any opportunityID (first time submitting the form), create a new filledForm
      createStep(arrayItems)
    } else {
      updateStep(arrayItems)
    }
    try {
      document.getElementById('uniform-detail-component').scrollIntoView()
      setTimeout(function () {
        window.scrollBy(0, 1)
      }, 100)
    } catch (e) {}
  }

  function createStep (arrayItems) {
    var data = createRestData()
    if (!data.fields.length) {
      for (var i = 0; i < arrayItems.length; i++) {
        data.fields.push({
          fieldId: arrayItems[i],
          values: [null]
        })
      }
    }

    if (!data.fields || !data.fields.length) {
      return
    }

    vm.disabledButton = true
    vm.showSpinner = true

    var deferred = $q.defer()
    uniformsService.create(data)
      .then(function (response) {
        vm.opportunityId = response.data.opportunityId

        response.data.messages = response.data.messages.filter(function (message) {
          return arrayItems.indexOf(message.fieldId) > -1
        })
        var responseStatus = response.data.messages.filter(function (message) {
          return message.messages
        })

        response.data.status = (responseStatus.length > 0) ? 'ERR' : 'OK'

        if (response.data.status === 'OK') {
          vm['form_' + vm.fullData.id].$setPristine()
          deferred.resolve()
        } else {
          if (response.data.messages) {
            vm.messagesFromBE = response.data.messages
            setValidity(vm.messagesFromBE)
            userTracking.onValidityFailure()
          }
          deferred.reject()
        }
      })
      .catch(function (error) {
        vm.isErrorBackend = true
        if (error && error.status === 400) {
          vm.isErrorBackend = false
        }
        deferred.reject()
      })
      .finally(function () {
        vm.disabledButton = false
        vm.showSpinner = false
        appLoader.hide()
      })
    vm.processPromise = deferred.promise
  }

  function updateStep (arrayItems) {
    var data = createRestData()

    if (!data.fields || !data.fields.length) {
      return
    }

    vm.disabledButton = true
    vm.showSpinner = true
    appLoader.show()
    var deferred = $q.defer()
    uniformsService.update(data, vm.opportunityId)
      .then(function (response) {
        response.data.messages = response.data.messages.filter(function (message) {
          return arrayItems.indexOf(message.fieldId) > -1
        })
        var responseStatus = response.data.messages.filter(function (message) {
          return message.messages
        })
        response.data.status = (responseStatus.length > 0) ? 'ERR' : 'OK'

        if (response.data.status === 'OK') {
          vm['form_' + vm.fullData.id].$setPristine()
          deferred.resolve()
        } else {
          if (response.data.messages) {
            vm.messagesFromBE = response.data.messages
            setValidity(vm.messagesFromBE)
            userTracking.onValidityFailure()
          }
          deferred.reject()
        }
      })
      .catch(function (error) {
        vm.isErrorBackend = true
        if (error && error.status === 400) {
          vm.isErrorBackend = false
        }
        deferred.reject()
      })
      .finally(function () {
        vm.disabledButton = false
        vm.showSpinner = false
        appLoader.hide()
      })
    vm.processPromise = deferred.promise
  }

  function saveOrSubmitStep () {
    var data = createRestData()

    if (!data.fields || !data.fields.length) {
      return
    }

    vm.disabledButton = true
    vm.showSpinner = true
    appLoader.show()
    vm['form_' + vm.fullData.id].$setSubmitted()
    uniformsService.update(data, vm.opportunityId)
      .then(function (response) {
        if (response.data.status === 'OK') {
          vm.disabledButton = true
          vm.showSpinner = true
          appLoader.show()
          uniformsService.submit(vm.opportunityId).then(function () {
            vm.submitedForm = true
          }).finally(function () {
            appLoader.hide()
            vm.disabledButton = false
            vm.showSpinner = false
          })
        } else {
          if (response.data.messages) {
            vm.messagesFromBE = response.data.messages
            setValidity(vm.messagesFromBE)
            userTracking.onValidityFailure()
          }
        }
      })
      .catch(function (error) {
        vm.isErrorBackend = true
        if (error && error.status === 400) {
          vm.isErrorBackend = false
        }
      })
      .finally(function () {
        vm.disabledButton = false
        vm.showSpinner = false
        appLoader.hide()
      })
  }

  function isIdVisible (id) {
    if (id !== null) {
      visibilityDependencyDataservice.isNodeVisible(id)
    }
  }
}
